var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_vm._l(([].concat(_vm.texts)),function(val,index){return [(val.highlight)?_c('strong',{key:index,staticClass:"highlight",attrs:{"data-qa":"highlighted"}},[_vm._v(_vm._s(val.text))]):_c('span',{key:index},[_vm._v(_vm._s(val.text))])]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }